import { JwtHelperService } from '@auth0/angular-jwt'
import { User } from '@helios/state-management'

/**
 * https://docs.cypress.io/guides/end-to-end-testing/auth0-authentication#Adapting-the-front-end
 * According to official cypress docs, we acquire the access token from the test script, then pass it to the app via localStorage.
 * This should not be a security concern because the browser environment used for the test environment will be wiped.
 *
 * The "test user" we use is a CIAM M2M user linked to legacyUserId 107279, and we get the token from Auth0's /oath/token endpoint
 * https://cwan.atlassian.net/wiki/spaces/IAM/pages/121373405/How+to+use+machine+credentials+for+test+automation
 */
export const TESTUSER_TOKEN_KEY = 'HELIOS_TESTUSER_TOKEN'

/**
 * @returns whether we're in an automated test environment, such as cypress integration test
 */
export function isTestAutomationAuth(): boolean {
  return localStorage.getItem(TESTUSER_TOKEN_KEY) != undefined
}

/**
 * @returns the access token for the automated test user from localstorage
 */
export function getTestAutomationAccessToken(): string | undefined {
  return localStorage.getItem(TESTUSER_TOKEN_KEY) ?? undefined
}

/**
 * @returns the User object for the testuser, given the access token
 */
export function getTestAutomationUser(accessToken: string): User {
  const jwtHelper = new JwtHelperService()
  const decodedToken = jwtHelper.decodeToken(accessToken)
  if (!decodedToken) throw new Error('failed to decode HELIOS_TESTUSER_TOKEN')

  const auth0Id = decodedToken['sub']
  const userData = decodedToken['http://clearwateranalytics.com/mcred']
  const clientId = userData['clientId']
  const rootClientId = userData['rootClientId']
  const legacyUserId = userData['legacyUserId']
  const realm = userData['realm']

  return {
    auth0Id,
    nickname: `Testy McUserface`,
    name: `HeliosTest-${legacyUserId}`,
    email: `heliostest-${legacyUserId}@clearwateranalytics.com`,
    clearwaterData: {
      clientId,
      rootClientId,
      legacyUserId,
      realm,
    },
  } as User
}
